import { render, staticRenderFns } from "./SubLicenseList.vue?vue&type=template&id=5166f763"
import script from "./SubLicenseList.vue?vue&type=script&lang=js"
export * from "./SubLicenseList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports